import React from 'react';
import '../../dashboard/Dashboard.css';
import './DeletePromotionButton.css';
import DeleteProductModal from '../../dashboard/components/product_item_components/DeleteProductModal';

/**
 * DELETE /operator/promotions/:promotionId — only when editing an existing promotion.
 */
export default function DeletePromotionButton({
  promotionId,
  promotionName,
  requestWithMeta,
  disabled = false,
  onDeleted,
}) {
  const [confirmOpen, setConfirmOpen] = React.useState(false);
  const [deleting, setDeleting] = React.useState(false);
  const [error, setError] = React.useState(null);

  if (!promotionId) return null;

  const displayName =
    String(promotionName ?? '').trim() || `Акция #${promotionId}`;

  const handleConfirmDelete = async () => {
    setError(null);
    setDeleting(true);
    try {
      const res = await requestWithMeta(
        `/operator/promotions/${encodeURIComponent(promotionId)}`,
        'DELETE'
      );
      if (res?.ok) {
        setConfirmOpen(false);
        onDeleted?.();
        return;
      }
      setError(
        res?.data?.error || res?.data?.message || 'Не удалось удалить акцию'
      );
    } catch (e) {
      setError(e?.message || 'Ошибка удаления');
    } finally {
      setDeleting(false);
    }
  };

  return (
    <>
      <button
        type="button"
        className="promotion-delete-button"
        disabled={disabled || deleting}
        onClick={() => {
          setError(null);
          setConfirmOpen(true);
        }}
      >
        Удалить
      </button>

      <DeleteProductModal
        isOpen={confirmOpen}
        onClose={() => {
          if (deleting) return;
          setConfirmOpen(false);
          setError(null);
        }}
        title="Удалить акцию"
        productName={displayName}
        deleteError={error}
        loading={deleting}
        onConfirmDelete={handleConfirmDelete}
      />
    </>
  );
}
